/**
 * This component renders a date box in the games header - Desktop only
 */
export default function DateBox({ day, month }) {
  return (
    <div className="bg-light-2 flex border-l-2 dark:border-dark-3 border-light-3 px-2 lg:px-3 py-5 flex-col justify-center items-center hidden md:flex dark:bg-dark-1 ">
      <p className="text-smm lg:text-sm">{month}</p>
      <p className="text-smm lg:text-sm">{day}</p>
    </div>
  );
}